import React from 'react'

class NotFound extends React.Component {
	render() {
		return (<div>Ups! este caminho não está definido ...</div>);
	}
}

let Router = {
	routes: {},
	breadcrumbs: [],
	active: null,

	isLoading: () => Router.active === null,

	set: (url, callback) => {
		let urlblocks = url.split('?', 2);
		let urlparts = urlblocks[0].replace(/^[\/#]+\/?/, '/').split('/');
		let route = Router.routes;
		let routing = []; // lista de routes por onde passou em arvore
		let params = {};
		let match = null;

		Router.active = null;
		// descodificar parametros depois do ? no url
		if (urlblocks.length > 1) {
			urlblocks[1].split('&').map(p => {
				p = p.split(/\=(.+)?/);
				params[p[0]] = p[1];
			});
		}
		Router.breadcrumbs = [];
		for (var k = 0, next = true; next; k++) {
			let part = urlparts[k] || '/';

			next = k < urlparts.length - 1 ? urlparts[k + 1] : '';
			// procura route 
			for (var link in route) {
				let id = null;

				if (link === part) {
					route = route[link];
				}
				else if (/^\d+$/.test(next) && (match = link.match(new RegExp(part + '/\:([a-z,_]+)'))) !== null) {
					route = route[link];
					id = params[match[1]] = next;
					next = (++k) < urlparts.length - 1 ? urlparts[k + 1] : '';
				}
				else {
					return { component: NotFound }; // nao encontrou route => NotFound
				}
				route.params = params;
				routing.push(route);
				Router.breadcrumbs.push({ link: link, label: route.breadcrumb.label, id: id });
				if (next) {
					if (!route.routes) {
						return { component: NotFound };
					}
					route = route.routes;
				}
			}
		}
		// verificar se existe algum router para carregar dados
		routing = routing.filter(r => r.component.loadData instanceof Function);
		let loads_count = routing.length;

		if (loads_count === 0) {
			Router.active = route;
			callback();
			return;
		}
		let loads_i = 0;

		while(routing.length > 0) {
			//route = routing.pop();
			(r => {
				http.open(r.loader.url,
					response => {
						r.data = response;
						if (loads_count == ++loads_i) {
							Router.active = r;
							callback();
						}
					},
					{ data: r.loader.params(r.params) }
				);
			})(routing.pop());
		}
	},

	find: (url, callback) => {
		let urlblocks = url.split('?', 2);
		let urlparts = urlblocks[0].replace(/^[\/#]+\/?/, '/').split('/');
		let route = Router.routes;
		let params = {};
		let match = null;

		// descodificar parametros depois do ? no url
		if (urlblocks.length > 1) {
			urlblocks[1].split('&').map(p => {
				p = p.split(/\=(.+)?/);
				params[p[0]] = p[1];
			});
		}
		Router.breadcrumbs = [];
		for (var k = 0, next = true; next; k++) {
			let part = urlparts[k] || '/';

			next = k < urlparts.length - 1 ? urlparts[k + 1] : '';
			// procura route 
			for (var link in route) {
				let id = null;

				if (link === part) {
					route = route[link];
				}
				else if (/^\d+$/.test(next) && (match = link.match(new RegExp(part + '/\:([a-z,_]+)'))) !== null) {
					route = route[link];
					id = params[match[1]] = next;
					next = (++k) < urlparts.length - 1 ? urlparts[k + 1] : '';
				}
				else {
					return { component: NotFound }; // nao encontrou route => NotFound
				}
				Router.breadcrumbs.push({ link: link, label: route.breadcrumb.label, id: id });
				if (next) {
					if (!route.routes) {
						return { component: NotFound };
					}
					route = route.routes;
				}
			}
		}
		route.params = params;
		return route;
	},

	linkTo: (url, params) => url.replace(/\:\w+/g, match => params[match.replace(':', '')] ),

	go: (to, absolute = false) => {
		if (to instanceof Object) {
			// calcular hash sem params
			var i = window.location.hash.indexOf('?');
			var hash = i > 0 ? window.location.hash.substring(0, i) : window.location.hash;

			to = hash.urlify(to);
		}
		if (!absolute) {
			window.location.hash = to;
		}
		else {
			window.location.href = to;
		}
	},

	goBack: () => {
		window.history.back();
	},

	reload: () => {
		window.location.reload();
	},

	listen: callback => {
		window.addEventListener('hashchange', l => {
			Router.active = Router.set(window.location.hash, () => callback(Router.active) );
		}, false);
		Router.set(window.location.hash, () => callback(Router.active) );
	},

	getBreadcrumbs: () => {
		let link = '';
		let parent = null;

		let breadcrumbs = Router.breadcrumbs.map((breadcrumb, i) => {
			let label = breadcrumb.label.replace(/(\{[a-z,_,.]+\})/g, match => {
				let parts = match.replace(/\{|\}/g, '').split('.');
				let model = hp.store.findModel(parts[0] == 'parent' ? parent[parts[1]] : parts[0], breadcrumb.id);
				return model ? model[parts[2] || parts[1]] : '';
			});
			link = (link + '/' + breadcrumb.link).replace(/^[\/]+/, '/').replace(/\:\w+/, breadcrumb.id || 0);
			parent = breadcrumb;
			return (
				<li key={i}>
					{i < Router.breadcrumbs.length - 1 ? <a href={'#' + link}>{label}</a> : label}
				</li>
			)
		});
		return (
			<ul className="breadcrumb">
				{breadcrumbs}
			</ul>
		)
	}
}

export default Router;
